<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2250_74472)">
<rect x="1" y="1" width="20" height="20" rx="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="3.4 5"/>
</g>
<defs>
<clipPath id="clip0_2250_74472">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
